import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoEyeHidden = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>EyeHidden</title>
    <path
      d="M29.382 4.615 24.74 9.256M4.616 29.381l4.525-4.526"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.681 21.73a5.778 5.778 0 0 0 8.049-8.049l-1.448 1.448a3.778 3.778 0 0 1-5.153 5.153l-1.448 1.447Zm5.187-8.016a3.778 3.778 0 0 0-5.153 5.153l-1.448 1.448a5.778 5.778 0 0 1 8.049-8.049l-1.448 1.448Z"
      fill="currentColor"
    />
    <path
      d="M3.576 15.554c3.913-5.924 8.39-8.701 13.422-8.701 5.031 0 9.51 2.777 13.422 8.7l.834-.55-.834.55a2.604 2.604 0 0 1 0 2.889c-3.907 5.923-8.385 8.7-13.422 8.7-5.037 0-9.515-2.777-13.423-8.7a2.603 2.603 0 0 1 .001-2.888Z"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
);
export default SvgIcoEyeHidden;
